export default __webpack_public_path__ + "static/media/loc-arte-8.4c3f01bf.webp";